module.exports = __webpack_public_path__ + "static/media/track-in-your-eyes.8a3cbf2f.png";